import * as React from "react";
import { forwardRef } from "react";
const SvgMaximize = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M20 4V20H22V4H20Z", fill: "#89A6FF" }), /* @__PURE__ */ React.createElement("path", { d: "M2 4L2 20H4L4 4H2Z", fill: "#89A6FF" }), /* @__PURE__ */ React.createElement("path", { d: "M13.59 14.59L15 16L19 12L15 8L13.59 9.41L15.17 11H8.83L10.41 9.41L9 8L5 12L9 16L10.41 14.59L8.83 13H15.17L13.59 14.59Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgMaximize);
export { ForwardRef as ReactComponent };
